import {
  Config,
  GameTypes,
  isPerformanceGame,
  PerformanceGameRewardModes
} from "kadow-jetpack-model";

// Performance games that can reward physical / coupon prizes, hence remain
// available when the monthly lottery is disabled and pgrm is "p" (Prize).
export const PHYSICAL_PRIZE_PERFORMANCE_GAMES = [
  GameTypes.PenaltyKick,
  GameTypes.Prognosis,
  GameTypes.SpaceInvaders,
  GameTypes.Breakout
];

// KadowCrush reports as a performance game but is handled as a game of chance.
function isGatedPerformanceGame(gameType: GameTypes): boolean {
  return gameType !== GameTypes.KadowCrush && isPerformanceGame(gameType);
}

// A performance game is unavailable when the monthly lottery is disabled,
// unless the reward mode is "p" (Prize) and the game can award physical /
// coupon prizes instead of monthly lottery tickets.
export function isPerformanceGameHiddenByDisabledMonthlyLottery(
  gameType: GameTypes,
  config: Config | null | undefined
): boolean {
  if (!isGatedPerformanceGame(gameType) || !config?.dml) {
    return false;
  }
  const rewardsPhysicalPrize =
    config?.pgrm === PerformanceGameRewardModes.Prize &&
    PHYSICAL_PRIZE_PERFORMANCE_GAMES.includes(gameType);
  return !rewardsPhysicalPrize;
}
